import React from 'react';
import { useIntl } from '@edx/frontend-platform/i18n';

import type { CohortThread } from '../../types';

import messages from './messages';
import { plainTextPreview } from './utils';

interface ThreadRowProps {
  thread: CohortThread;
  onDeleteClick: () => void;
}

const ThreadRow: React.FC<ThreadRowProps> = ({ thread, onDeleteClick }) => {
  const intl = useIntl();
  const preview = plainTextPreview(thread.body_preview);

  return (
    <li className="cohort-discussions-thread">
      <div className="cohort-discussions-thread-main">
        <div className="cohort-discussions-thread-title">{thread.title}</div>
        {preview && (
          <p className="cohort-discussions-thread-preview">{preview}</p>
        )}
        <div className="cohort-discussions-thread-meta">
          {intl.formatMessage(messages.discussionsThreadAuthorLabel, {
            authorName: thread.author_name || intl.formatMessage(messages.discussionsUnknownAuthor),
          })}
          {' · '}
          {intl.formatDate(thread.created_at, { year: 'numeric', month: 'long', day: 'numeric' })}
          {' · '}
          {intl.formatMessage(messages.discussionsThreadReplyCountLabel, { count: thread.comments_count })}
        </div>
      </div>
      <button
        type="button"
        className="cohort-discussions-delete-button"
        onClick={onDeleteClick}
      >
        {intl.formatMessage(messages.discussionsDeleteButton)}
      </button>
    </li>
  );
};

export default ThreadRow;
